import { useEffect, useRef } from "react";
import { useGoogleMap } from "@ubilabs/google-maps-react-hooks";
import { crearTallerMarker, limpiarTalleres } from "./talleresMap";

const TalleresMarkersInner = ({ talleres, map, setLatLng }) => {
  const markersRef = useRef([]);
  const infoWindowRef = useRef(null);

  useEffect(() => {
    if (!map || !talleres) return;

    limpiarTalleres(markersRef, null);
    if (infoWindowRef.current) infoWindowRef.current.close();
    infoWindowRef.current = new window.google.maps.InfoWindow({ headerDisabled: false });

    talleres.forEach((taller) => {
      const marker = crearTallerMarker({ map, taller, infoWindowRef, setLatLng });
      if (marker) markersRef.current.push(marker);
    });

    return () => {
      if (infoWindowRef.current) infoWindowRef.current.close();
      limpiarTalleres(markersRef, talleres);
    };
  }, [map, talleres]);

  return null;
};

export const TalleresMarkers = ({ talleres, setLatLng }) => {
  const map = useGoogleMap();
  return <TalleresMarkersInner talleres={talleres} map={map} setLatLng={setLatLng} />;
};
